module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/offerta-min-descrizione/offerta-min-descrizione.component.scss
// module id = ./src/app/offerta-min-descrizione/offerta-min-descrizione.component.scss
// module chunks = main